/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    accordionNextButton: {
        id: 'accordion.nextButton',
        defaultMessage: 'Next'
    },
    ModalMessageClose: {
        id: 'modal.closeButton',
        defaultMessage: 'Close'
    },
    ModalMessageCancel: {
        id: 'modal.cancelButton',
        defaultMessage: 'Cancel'
    },
    ModalMessageConfirm: {
        id: 'modal.confirmButton',
        defaultMessage: 'Confirm'
    },
    ModalMessageOK: {
        id: 'modal.okButton',
        defaultMessage: 'OK'
    },
    editButton: {
        id: 'editButton',
        defaultMessage: 'Edit'
    },
    removeButton: {
        id: 'removeButton',
        defaultMessage: 'Remove'
    },
    yourPossessivePronoun: {
        id: 'yourPossessivePronoun',
        defaultMessage: 'your'
    },
    theirPossessivePronoun: {
        id: 'theirPossessivePronoun',
        defaultMessage: 'their'
    },
    yourPossessivePronounUpper: {
        id: 'yourPossessivePronounUpper',
        defaultMessage: 'Your'
    },
    theirPossessivePronounUpper: {
        id: 'theirPossessivePronounUpper',
        defaultMessage: 'Their'
    },
    theyPronoun: {
        id: 'theyPronoun',
        defaultMessage: 'they'
    },
    themPronoun: {
        id: 'themPronoun',
        defaultMessage: 'them'
    },
    youPronoun: {
        id: 'youPronoun',
        defaultMessage: 'you'
    },
    SubLabelShowMore: {
        id: 'SubLabelShowMore',
        defaultMessage: 'Show more'
    },
    SubLabelShowLess: {
        id: 'SubLabelShowLess',
        defaultMessage: 'Show less'
    },
    yes: {
        id: 'common.yes',
        defaultMessage: 'Yes'
    },
    no: {
        id: 'common.no',
        defaultMessage: 'No'
    },
    edit: {
        id: 'common.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'common.remove',
        defaultMessage: 'Remove'
    },
    date: {
        id: 'common.date',
        defaultMessage: 'Date'
    },
    type: {
        id: 'common.Type',
        defaultMessage: 'Type'
    },
    PrivateHome: {
        id: 'PrivateHome',
        defaultMessage: 'Home'
    },
    PrivateMotor: {
        id: 'PrivateMotor',
        defaultMessage: 'Car'
    },
    PrivateMedicalInsurance: {
        id: 'PrivateHealth',
        defaultMessage: 'Private Health'
    },
    Confirmed: {
        id: 'common.Confirmed',
        defaultMessage: 'Confirmed'
    },
    QuoteSavedToMySagaInfo: {
        id: 'common.QuoteSavedToMySagaInfo',
        defaultMessage: 'Your quote will be saved to the MySaga account that is linked to email address {email}. Please note that if this email address is shared, the other party may view any communications we send to you via MySaga.'
    },
    EmailAddressLabel: {
        id: 'common.EmailAddressLabel',
        defaultMessage: 'What is your email address?'
    },
    EmailSubLabel: {
        id: 'common.EmailSubLabel',
        defaultMessage: 'We need your email address to send your policy documentation.'
    },
    ConfirmEmailAddressLabel: {
        id: 'common.ConfirmEmailAddressLabel',
        defaultMessage: 'Confirm your email address'
    },
    QuotePageHeader: {
        id: 'common.QuotePageHeader',
        defaultMessage: 'Here is your {product} insurance quote, {firstName}'
    }
});
